module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzY4IiBoZWlnaHQ9IjgwIiB2aWV3Qm94PSIwIDAgNzY4IDgwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iNzY4IiBoZWlnaHQ9IjgwIiBmaWxsPSIjMTAxMDEwIi8+CjxwYXRoIGQ9Ik0tNi4xMDM1MmUtMDUgMFY4MEg3NjhMLTYuMTAzNTJlLTA1IDBaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/sanjiao4.svg
// module id = DrGK
// module chunks = 13